import { createSelector } from '@reduxjs/toolkit';
import { selectReportSettingsState } from '../../store/selectors';

export const selectAfsls = createSelector(selectReportSettingsState, (settingsState) => settingsState.afsls);

export const selectAfslId = createSelector(selectReportSettingsState, (settingsState) => settingsState.afslId);

export const selectAssetClassOrderItems = createSelector(selectReportSettingsState, (settingsState) => settingsState.assetClassOrderGridState);

export const selectAssetClassOverrideItems = createSelector(selectReportSettingsState, (settingsState) => settingsState.assetClassOverrideGridState);
